import '@mdi/font/css/materialdesignicons.css';
import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import colors from 'vuetify/lib/util/colors';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        options: {
            customProperties: true
        },
        themes: {
            light: {
                primary: colors.green,        
                secondary: colors.grey.darken1,
                accent: colors.purple,
                error: colors.red.accent3,
                warning: colors.orange.accent4,
                info: colors.cyan
            }
        }
    }
});
